const CDN_ENDPOINT = "https://essexair-api.cms42.com/api"

const CDN_SEND_LINK = "/fe/v1.0/authenticate/sendpasswordlesslogin"

const CDN_CHECK = "/ckfindersharedscripts/connector?command=Init"

const CDN_FOLDERS =
  "/ckfindersharedscripts/connector?command=GetFolders&lang=en&type=shared"

const CDN_FILES =
  "/ckfindersharedscripts/connector?command=GetFiles&lang=en&type=shared"

const CDN_DOWNLOAD =
  "/ckfindersharedscripts/connector?command=DownloadFile&lang=en&type=shared"

const CDN_GENERATE_TOKEN = "/fe/v1.0/authenticate/passwordlesslogin"

const DEFAULT_FOLDER = "/"

export const sendPasswordlessLogin = async (email) => {
  const output = await fetch(
    `${CDN_ENDPOINT}${CDN_SEND_LINK}?email=${encodeURIComponent(email)}`,
    {
      method: "GET",
      headers: {
        SiteId: process.env.REACT_APP_LA_DEFAULT,
        usecache: "false",
      },
    },
  )
  return output
}

export const generateToken = async (userId, token) => {
  const myHeaders = new Headers()
  myHeaders.append("SiteId", process.env.REACT_APP_LA_DEFAULT)
  myHeaders.append("Content-Type", "application/json")

  const raw = JSON.stringify({
    id: encodeURIComponent(userId),
    token: token,
  })

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  const response = await fetch(
    `${CDN_ENDPOINT}${CDN_GENERATE_TOKEN}`,
    requestOptions,
  )
  return response
}

export const getFolders = async (
  currentFolder = DEFAULT_FOLDER,
  access_token,
) => {
  const response = await fetch(
    `${CDN_ENDPOINT}${CDN_FOLDERS}&currentFolder=${currentFolder}&access_token=${access_token}`,
  )
  return response.json()
}

export const getFiles = async (
  currentFolder = DEFAULT_FOLDER,
  access_token,
) => {
  const response = await fetch(
    `${CDN_ENDPOINT}${CDN_FILES}&currentFolder=${currentFolder}&access_token=${access_token}`,
  )
  return response.json()
}

export const getDownloadLink = (
  currentFolder = DEFAULT_FOLDER,
  fileName,
  access_token,
) => {
  return `${CDN_ENDPOINT}${CDN_DOWNLOAD}&currentFolder=${currentFolder}&fileName=${fileName}&access_token=${access_token}`
}

export const checkValidToken = async (access_token) => {
  const response = await fetch(
    `${CDN_ENDPOINT}${CDN_CHECK}&access_token=${access_token}`,
  )
  return response
}
